/**
 * https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
 * SHA256 is a hashing function not an encryption function.
 * Since SHA256 is not an encryption function, it cannot be decrypted.
 */
export const sha256 = async (text: string) => {
    try{
        // encode as UTF-8
        // @ts-ignore
        const msgBuffer = new window.TextEncoder().encode(text);

        // hash the message
        // @ts-ignore
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);

        // convert ArrayBuffer to Array
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        // convert bytes to hex string
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }
    catch (ex) {
        console.log(ex);
    }
};
